"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDealInfoByType = exports.getPricingPlanInfo = exports.getRentPriceInfo = exports.getSalePriceInfo = exports.getSubscriptionPriceInfo = exports.hasEnabledPriceInfo = exports.getMinPriceInfo = void 0;
var deal_info_types_1 = require("@wix/wix-vod-constants/dist/common/deal-info-types");
var lodash_1 = require("lodash");
function getMinPriceInfo(dealInfo) {
    var enabledDealInfo = (dealInfo || []).filter(function (d) { return d.enabled; });
    if (!enabledDealInfo.length) {
        return null;
    }
    return (0, lodash_1.minBy)(enabledDealInfo, 'price');
}
exports.getMinPriceInfo = getMinPriceInfo;
function hasEnabledPriceInfo(dealInfo) {
    return (dealInfo || []).some(function (d) { return d.enabled; });
}
exports.hasEnabledPriceInfo = hasEnabledPriceInfo;
function buildGetPriceInfo(type) {
    return function (dealInfo) {
        return (dealInfo || []).find(function (d) { return d.enabled && d.type === type; }) || null;
    };
}
exports.getSubscriptionPriceInfo = buildGetPriceInfo(deal_info_types_1.DEAL_INFO_TYPES.SUBSCRIPTION);
exports.getSalePriceInfo = buildGetPriceInfo(deal_info_types_1.DEAL_INFO_TYPES.SALE);
exports.getRentPriceInfo = buildGetPriceInfo(deal_info_types_1.DEAL_INFO_TYPES.RENT);
exports.getPricingPlanInfo = buildGetPriceInfo(deal_info_types_1.DEAL_INFO_TYPES.PLAN);
function getDealInfoByType(dealInfo, type) {
    switch (type) {
        case deal_info_types_1.DEAL_INFO_TYPES.SALE:
            return (0, exports.getSalePriceInfo)(dealInfo);
        case deal_info_types_1.DEAL_INFO_TYPES.RENT:
            return (0, exports.getRentPriceInfo)(dealInfo);
        case deal_info_types_1.DEAL_INFO_TYPES.SUBSCRIPTION:
            return (0, exports.getSubscriptionPriceInfo)(dealInfo);
        case deal_info_types_1.DEAL_INFO_TYPES.PLAN:
            return (0, exports.getPricingPlanInfo)(dealInfo);
        default:
            return {};
    }
}
exports.getDealInfoByType = getDealInfoByType;
//# sourceMappingURL=deal-info-helpers.js.map